import type { MenuSchema } from '../MenuSchema.js';

export const REMOTE_DEVICE_CONN_MENU_ACTIONS = {
    connect: 'remote-device-connect',
} as const;

export function createRemoteDeviceConnMenuSchema(): MenuSchema {
    return {
        id: 'REMOTEDEVICECONN',
        title: 'Remote Device Connection',
        nodes: [
            { type: 'text', text: "Connect to Another User's Devices" },
            { type: 'input', id: 'remote-device-key-input', placeholder: "User's Key", get: () => '' },
            { type: 'button', id: REMOTE_DEVICE_CONN_MENU_ACTIONS.connect, label: 'Connect' },
        ],
    };
}
